import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import DeleteRegionModal from "routes/regions/modals/DeleteRegionModal";
import EditRegionModal from "routes/regions/modals/EditRegionModal";

export function RegionsTableActions({ original, onSuccess }) {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.region.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.region.delete]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Region actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <EditRegionModal
        id={original.id}
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={onSuccess}
      />
      <DeleteRegionModal
        id={original.id}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        onSuccess={onSuccess}
      />
    </>
  );
}
